<template>
  <div class="quality-component">
    <div class="area">
      <div class="row quality-container" v-animated-show="utils.handleScroll">
        <section class="main-desc col-4 col-md-12 gap-offset">
          <Description
            class="main small icon-top"
            ref="mainDescription"
            :title="info.title"
            :desc="info.desc"
            :icon="info.icon"
            href="#callback"
          />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
export default {
  name: "Advantage",
  props: {
    info: Object,
  },
  data() {
    return { utils: utils };
  },
  // methods: {
  //   onScroll() {},
  // },
  // mounted() {
  //   window.addEventListener("scroll", onScroll);
  // },
};
</script>

<style lang="scss">
$bg-position: var(--bg-position);
.quality-component {
  background: url(../assets/photos/main/banner4@2x.jpg) top center;
  position: relative;
  padding-top: 0;
  top: -60px;
  z-index: 0;
  background-size: cover;
  position: relative;
  overflow: hidden;
  background-position-y: $bg-position;
  &::before {
    background: url(../assets/photos/main/quality_mask_top.svg) top center
      repeat-x;
    background-size: 1200px 190px;
    position: absolute;
    left: 0;
    top: -50px;
    right: 0;
    height: 190px;
    content: "";
    z-index: 0;
  }
  &::after {
    background: url(../assets/photos/main/quality_mask_bottom.svg) top center
      repeat-x;
    background-size: 1200px 190px;
    position: absolute;
    left: 0;
    bottom: -50px;
    right: 0;
    height: 190px;
    content: "";
    z-index: 0;
  }
  // -webkit-mask-image: url(../assets/photos/main/quality_mask.svg);
  // mask-image: url(../assets/photos/main/quality_mask.svg);
  @extend %page-block;
  @media all and (max-width: $md) {
    padding-top: 168px;
    padding-bottom: 88px;
  }
  .area {
    z-index: 1;
    position: relative;
  }
  .main-desc {
    @media all and (max-width: $md) {
      grid-column: 4 / span 6;
      margin-left: 0;
      margin-right: 0;
      margin-top: 40px;
      margin-bottom: -80px;
    }
    @media all and (max-width: $sm) {
      grid-column: 1 / span 12;
      margin-left: 0;
      margin-right: 0;
    }
    margin-top: 280px;
    grid-column: 5 / span 4;
    margin-left: -26px;
    margin-right: -26px;
    @extend %pattern;
    color: white;
    text-align: center;
    .icon::before {
      color: $color-accent !important;
      font-size: 56px;
    }
    padding-top: 50px;
    padding-bottom: 42px;
  }
  .description {
    padding: 0 26px;
  }
  .row {
    grid-row-gap: 28px;
    &.advantage-container {
      position: relative;
      @media all and (max-width: $md) {
        grid-row-gap: 28px;
      }
    }
  }
}
</style>
